import { __rest } from "tslib";
import React, { useState } from 'react';
import moment, { isMoment } from 'moment';
import DatePicker from 'react-datepicker';
import { CustomDatePickerInput } from './ScheduleDatePicker';
import './timesteppicker.scss';
const TimeStepPicker = (_a) => {
    var { style, className, onChange, timeIntervals = 15, disabled, defaultTime = true, filterTime, onKeyDown } = _a, props = __rest(_a, ["style", "className", "onChange", "timeIntervals", "disabled", "defaultTime", "filterTime", "onKeyDown"]);
    const [selected, setSelected] = useState(defaultTime ? new Date() : null);
    const handleChange = date => {
        if (!Array.isArray(date)) {
            if (onChange) {
                onChange(date ? moment(date) : null);
            }
            else {
                setSelected(date);
            }
        }
    };
    const value = isMoment(props.value) ? props.value.toDate() : selected;
    return (React.createElement("div", { className: "sirius-time-picker-wrapper" },
        React.createElement(DatePicker, { disabled: disabled, closeOnScroll: !0, customInput: React.createElement(CustomDatePickerInput, { disabled: disabled, className: "input", style: Object.assign({}, style) }), isClearable: false, showPopperArrow: false, selected: value, onChange: handleChange, showTimeSelect: true, showTimeSelectOnly: true, timeIntervals: timeIntervals, dateFormat: "HH:mm", timeFormat: "HH:mm", renderCustomHeader: () => React.createElement("span", null), timeCaption: "", timeClassName: () => 'sirius-time-picker-timeli', filterTime: filterTime, onKeyDown: onKeyDown })));
};
export default TimeStepPicker;
